import { jsx } from 'react/jsx-runtime';
import { SidenavItem } from '../Sidenav.Item/Sidenav.Item.es.js';

const SidenavGroupItem = (props)=>{
    return jsx(SidenavItem, {
        ...props
    });
};
SidenavGroupItem.displayName = 'Sidenav.Group.Item';

export { SidenavGroupItem };
//# sourceMappingURL=Sidenav.Group.Item.es.js.map
